import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    GetAllTicketsMethod,
    ticketsReset,
} from "../../Redux/TicketsSlice/TicketsSlice";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import {
    Grid,
    IconButton,
    Typography,
    TablePagination,
    Box,
} from "@mui/material";
import SingleTicket from "./Layouts/SingleTicket";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";

function AllTickets() {
    const dispatch = useDispatch();

    const { tickets, isLoading } = useSelector((state) => state.tickets);

    const ticketsValue = tickets?.data?.data;
    const TeckitPagination = tickets?.data;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        const callSearchAction = async () => {
            await dispatch(
                GetAllTicketsMethod({
                    paginate: rowsPerPage,
                    page: newPage + 1,
                })
            );
            await dispatch(ticketsReset());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            await dispatch(
                GetAllTicketsMethod({ paginate: event.target.value })
            );
            await dispatch(ticketsReset());
        };
        callSearchAction();
    };

    useEffect(() => {
        const GetAllTickets = async () => {
            await dispatch(GetAllTicketsMethod());
            await dispatch(ticketsReset());
        };
        GetAllTickets();
    }, []);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <>
                    <Grid container spacing={2}>
                        {ticketsValue?.map((data) => (
                            <Grid key={data.id} item md={6} sm={6} mt={2}>
                                <SingleTicket e={data} />
                            </Grid>
                        ))}
                    </Grid>
                    <Box>
                        {TeckitPagination?.total >= 10 && (
                            <TablePagination
                                // rowsPerPageOptions={[
                                //     10,
                                //     50,
                                //     100,
                                //     { label: "All", value: -1 },
                                // ]}
                                colSpan={12}
                                count={TeckitPagination?.total}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                    </Box>
                </>
            )}
        </>
    );
}

export default AllTickets;
